module.exports = __webpack_public_path__ + "img/ctrl-u1-dagger-stub--.57bfae3c.svg";